// Chat widget show/hide helpers.
//
// Teams Live Chat (teamsChat flag): the widget has no SDK. We manage visibility
// via DOM/CSS based on a three-phase lifecycle:
//   Phase 1 — page load:   button (.chatclient-button) is in the PARENT document
//   Phase 2 — chat open:   iframe expands to full chat window
//   Phase 3 — chat closed: button is now INSIDE the cross-origin iframe
//
// Zopim/Zendesk (fallback): straightforward SDK calls.

(function() {
  function init(features) {
  var teamsEnabled = !!features.teamsChat;

  if (!teamsEnabled) {
    window.showChat = function() { window.$zopim(function() { window.$zopim.livechat.window.show(); }); };
    window.hideChat = function() { window.$zopim(function() { window.$zopim.livechat.hideAll(); }); };
  }

  var BUTTON_MAX_PX = 120; // iframe style width/height ~86px in button state

  var parentBtn = null;  // phase 1
  var frame     = null;  // phases 2+3
  var ignoringFrameMutation = false;

  function hideFrame() {
    if (!frame) return;
    ignoringFrameMutation = true;
    frame.style.display = 'none';
  }

  if (teamsEnabled) {
    window.showChat = function() {
      if (parentBtn) {
        // Phase 1: button is in parent DOM — click directly
        parentBtn.click();
      } else if (frame) {
        // Phase 3: button is inside cross-origin iframe — un-hide so user can click it
        ignoringFrameMutation = true;
        frame.style.removeProperty('display');
      }
    };

    window.hideChat = function() {
      if (parentBtn) {
        parentBtn.style.setProperty('visibility', 'hidden', 'important');
        parentBtn.style.setProperty('pointer-events', 'none', 'important');
      }
      hideFrame();
    };
  }

  // Always watch for the Teams button — hide it permanently when teamsChat is off,
  // or manage it via showChat/hideChat lifecycle when on.
  new MutationObserver(function(mutations, btnObs) {
    var btn = document.querySelector('.chatclient-button');
    if (!btn) return;
    btnObs.disconnect();
    btn.style.setProperty('visibility', 'hidden', 'important');
    btn.style.setProperty('pointer-events', 'none', 'important');

    if (!teamsEnabled) return;

    parentBtn = btn;

    // Step 2: watch for the iframe to appear (first time user opens chat)
    new MutationObserver(function(mutations, frameObs) {
      var f = document.querySelector('iframe[id^="teams-chat-bot-iframe"]');
      if (!f) return;
      frameObs.disconnect();
      frame = f;
      parentBtn = null; // button is now inside the iframe

      // Step 3: watch iframe style — widget changes width/height to signal state
      new MutationObserver(function() {
        if (ignoringFrameMutation) {
          ignoringFrameMutation = false;
          return;
        }
        // Read from inline style (not offsetWidth — avoids reflow timing issues)
        var w = parseInt(frame.style.width)  || 0;
        var h = parseInt(frame.style.height) || 0;
        var isButtonState = w > 0 && w <= BUTTON_MAX_PX && h > 0 && h <= BUTTON_MAX_PX;

        if (isButtonState) {
          hideFrame();
        }
      }).observe(frame, { attributes: true, attributeFilter: ['style'] });

    }).observe(document.body, { childList: true, subtree: true });

  }).observe(document.body, { childList: true, subtree: true });
  }

  if (window.__features) {
    init(window.__features);
  } else {
    window.addEventListener('featuresLoaded', function(e) { init(e.detail); }, { once: true });
  }
})();
